<div class="c-card c-card--height-fit">
	<h3 class="u-sr-only">{{ vm.service?.user?.firstname }} {{ vm.service?.user?.lastname }}</h3>
	<div class="c-content c-content--border-bottom@md-and-up c-content--wrapper">
		<div class="o-grid o-grid--wrap o-grid--center-v">
			<div class="o-grid__cell u-no-p" *ngIf="!vm.isMinimal && !vm.partnerMode">
				<p class="c-text {{vm.serviceTimeAndPriceTheme}} u-ost-xs" *ngIf="vm.service?.nextAvailableTime">
					{{ 'Services.Time.Earliest' | translate }}, <span class="c-text c-text--bold">{{ vm.service?.nextAvailableDate }} {{ vm.service?.nextAvailableTime | date:'HH:mm' }}</span>
				</p>
				<p class="c-text {{vm.serviceTimeAndPriceTheme}} u-ost-xs" *ngIf="!vm.service?.nextAvailableTime && !vm.service?.chatBot">{{ 'Services.Time.Not_Available' | translate }}</p>
				<p class="c-text {{vm.serviceTimeAndPriceTheme}} u-ost-xs" *ngIf="vm.service?.chatBot">{{ 'Services.Time.Available_Now' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" [ngClass]="{'o-grid__cell--o2': vm.isMinimal}" *ngIf="(vm.partnerMode && vm.service?.pricing?.price !== null && vm.service?.pricing?.price !== undefined) || (!vm.partnerMode && !vm.isCoveredByBusinessWallet && vm.service?.pricing.price > 0)">
				<p class="c-text {{vm.serviceTimeAndPriceTheme}}">
					<span class="c-text c-text--bold c-text--lg">{{ vm.service?.priceWithUnits }}</span><span *ngIf="(vm.partnerMode && vm.service?.pricing?.timePerPrice) || vm.service?.subcategory==='PSYCHOLOGY' || vm.service?.subcategory==='COACHING'">/{{vm.service?.pricing.timePerPrice}}{{ 'Units.Minutes' | translate | lowerCase }}</span><span class="c-text c-text--lg u-hidden@md-and-up" *ngIf="vm.service?.priceDisclaimer">*</span>
					<item-info-popover [itemId]="vm.service?.id" [text]="vm.service?.priceDisclaimer" placement="bottom" (click)="$event.preventDefault()" *ngIf="vm.service?.priceDisclaimer" class="u-osl-xs u-hidden@up-to-md"></item-info-popover>
				</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!vm.isMinimal && vm.isSiffi && vm.showBusinessWalletLabel">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
						<div [ngClass]="{'c-label--s0':  vm.walletName?.toLowerCase() === 'iizi', 'c-label--s2':  vm.walletName?.toLowerCase() !== 'iizi'}" class="c-label c-label--s4">
							<i [ngClass]="{'o-icon--check':  vm.walletName?.toLowerCase() === 'iizi', 'o-icon--user':  vm.walletName?.walletName?.toLowerCase()() !== 'iizi'}" class="o-icon" aria-hidden="true"></i>
							{{ vm.walletName ? (vm.getBusinessWalletLabel() | translate).replace('%s', vm.walletName) : ('Services.Other.Covered_By_Employer' | translate) }}
						</div>
					</div>
				</div>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--o1 u-no-p" *ngIf="vm.isMinimal && vm.showBusinessWalletLabel">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
						<div [ngClass]="{'c-label--s0':  vm.walletName?.toLowerCase() === 'iizi', 'c-label--s2':  vm.walletName?.toLowerCase() !== 'iizi'}" class="c-label c-label--s4">
							<i [ngClass]="{'o-icon--check':  vm.walletName?.toLowerCase() === 'iizi', 'o-icon--user':  vm.walletName?.toLowerCase() !== 'iizi'}" class="o-icon" aria-hidden="true"></i>
							{{ vm.walletName ? (vm.getBusinessWalletLabel() | translate).replace('%s', vm.walletName) : ('Services.Other.Covered_By_Employer' | translate) }}
						</div>
					</div>
				</div>
			</div>
			<div class="o-grid__cell u-no-p" [ngClass]="{'o-grid__cell--o1': vm.isMinimal && vm.isMinuDoc && !vm.showBusinessWalletLabel, 'o-grid__cell--o2': vm.isMinimal && vm.showBusinessWalletLabel, 'o-grid__cell--w-100 u-ost-md': !vm.isMinimal, 'u-ost-md': vm.showBusinessWalletLabel || !vm.isMinimal, 'u-ost-xs o-grid__cell--o1': vm.isSiffi && vm.isMinimal && !vm.showBusinessWalletLabel}" *ngIf="vm.isInitialized">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p">
						<list-language-flags *ngIf="!vm.service?.chatBot" [languages]="vm.service?.languages"></list-language-flags>
						<span *ngIf="vm.service?.chatBot">{{ 'Services.Other.Any_Language' | translate }}</span>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!vm.isMinimal && vm.isMinuDoc && vm.showBusinessWalletLabel">
						<div [ngClass]="{'c-label--s0':  vm.walletName?.toLowerCase() === 'iizi', 'c-label--s2':  vm.walletName?.toLowerCase() !== 'iizi'}" class="c-label c-label--s4">
							<i [ngClass]="{'o-icon--check':  vm.walletName?.toLowerCase() === 'iizi', 'o-icon--user':  vm.walletName?.toLowerCase() !== 'iizi'}" class="o-icon" aria-hidden="true"></i> {{ vm.walletName ? (vm.getBusinessWalletLabel() | translate).replace('%s', vm.walletName) : ('Services.Other.Covered_By_Employer' | translate) }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="o-grid o-grid--wrap o-grid--center-v">
			<div class="o-grid__cell u-no-p" style="margin-top: 5px;">
				<div class="o-grid">
					<div *ngIf="vm.service?.location" class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<img id="locationIcon{{vm.service?.id}}" alt="Location" src="{{vm.isSiffi ? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/location-icon-siffi.svg' : 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/location-icon-minudoc.svg'}}" style="height: 18px; width: 18px; margin: 5px 5px 0 0" />
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" style="margin-top: 5px;">
						<span *ngIf="vm.service?.location" class="c-text u-osb-xs" style="margin-right: 10px">{{ vm.service?.location }}</span>
						<i *ngIf="vm.service?.furtherSubcategory !== 'AI_COUNSELLOR'"
                           class="o-icon o-icon--video"
						   [style.color]="vm.getIconColor('video')"
						   title="Video session"
						   style="margin-right: 10px; cursor: default;">
						</i>
						<i *ngIf="vm.service?.furtherSubcategory !== 'AI_COUNSELLOR'"
                           class="o-icon o-icon--home"
						   [style.color]="vm.getIconColor('onsite')"
						   title="Face-to-face session"
						   style="margin-right: 10px; cursor: default;">
						</i>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="c-content c-content--wrapper" [ngClass]="{'c-content--grow': !vm.partnerMode, 'u-no-p': !vm.isMinimal || vm.service?.priceDisclaimer, 'u-no-pt u-no-ph': vm.isMinimal}" [ngStyle]="{'min-height': (vm.isMinimal || vm.partnerMode) ? null : '220px'}">
		<div class="o-media c-content u-no-pb u-ost-sm u-osb-xs">
			<div class="o-media__img" style="cursor: pointer" (click)="vm.redirectToDoctorDetails()">
				<avatar [user]="vm.service?.user" [default]="'doctor'"></avatar>
				<div style="position:relative;bottom:15px;left:45px;width:20px;" *ngIf="vm.service?.discountPricingSupported">
                    <div class="heart-top"></div>
                    <div class="heart-bottom"></div>
                </div>
			</div>
			<div class="o-media__body">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--slim u-no-p">
						<p class="c-text c-text--bold c-text--lg u-osb-xs" style="cursor: pointer" (click)="vm.redirectToDoctorDetails()">
							{{ vm.service?.user?.firstname }} {{ vm.service?.user?.lastname }}
						</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-xs">
						<item-rating [model]="vm.service?.userRating" [maxRating]="5" [size]="'sm'"></item-rating>
					</div>
				</div>
				<p class="c-text {{vm.textColor}}">{{ vm.service?.occupation }}{{ vm.service?.company }}</p>
				<p class="c-text {{vm.textColor}}" *ngIf="vm.service?.license">{{ vm.service?.license }}</p>
			</div>
		</div>
		<div class="c-content" aria-hidden="true" *ngIf="!vm.partnerMode && (!vm.isMinimal || vm.service?.priceDisclaimer)">
			<p class="c-text c-text--wrap c-text--bold u-hidden@md-and-up" [ngClass]="{'u-osb-md': !vm.isMinimal}" *ngIf="vm.service?.priceDisclaimer">* {{ vm.service?.priceDisclaimer }}</p>
			<p class="c-text c-text--wrap" *ngIf="!vm.isMinimal">{{ vm.service?.description | arrayLimitTo:vm.charLimit }}<span *ngIf="vm.service?.description?.length > vm.charLimit">... </span><a style="cursor:pointer;font-weight:600" class="u-no-wrap" tabindex="-1" *ngIf="vm.service?.description?.length > vm.charLimit" (click)="vm.openDescription()">{{ 'Services.Button.Read_More' | translate }}</a></p>
		</div>
		<div class="c-therapies__wrapper__start" *ngIf="!vm.partnerMode">
			<div *ngFor="let therapy of vm.selectedTherapies | startFrom: 0 | arrayLimitTo: 2 ; let $index=index"
					 [ngClass]="{'c-therapies_wrapper__last': $index == 1}"
					 (click)="vm.redirectToDoctorDetails()"
					 class="c-therapies"
					 style="display: table-cell; cursor: pointer">
				<p [ngClass]="{'c-therapies__last': $index == 1}">{{ $index == 0 ? therapy.translation : ' +' + vm.selectedTherapiesLengthWithoutFirst}}</p>
				<div *ngIf="$index == 0" class="tooltiptext">{{therapy.description}}</div>
			</div>
		</div>
		<div class="o-grid" style="padding: 5px 20px">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="vm.service?.linkedinUrl">
				<a id="linkedin{{vm.service?.id}}" href="{{vm.service?.linkedinUrl}}" target="_blank">
					<img id="linkedinIcon{{vm.service?.id}}" alt="LinkedIn link" class="u-osr-xs" style="margin-top: -1px" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/linkedin-icon.svg" height="22px" width="22px"/>
				</a>
				</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="vm.service?.websiteUrl">
				<a id="website{{vm.service?.id}}" href="{{vm.service?.websiteUrl}}" target="_blank">
					<img id="websiteIcon{{vm.service?.id}}" alt="Website link" class="u-osr-xs" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/website-icon.svg" height="20px" width="20px"/>
				</a>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!!vm.service?.profileVideoPost?.fileUrl" style="margin-left: 3px">
				<div class="o-grid">
					<div style="border-left: 1px solid #d1d1d1; width: 1px; height: 20px; margin-right: 10px" *ngIf="vm.service?.linkedinUrl || vm.service?.websiteUrl"></div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<a href="javascript:void(0)" id="watchVideo{{vm.service?.id}}" style="cursor:pointer;" (click)="vm.openVideo($event)" >
							<img id="video{{vm.service?.id}}" alt="Watch video" class="u-osr-xs" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/watch-video-icon.svg" style="margin-top: 1px" height="18px" width="18px"/>
						</a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<a href="javascript:void(0)" id="openVideo{{vm.service?.id}}" style="cursor:pointer;" (click)="vm.openVideo($event)" >
							<p class="c-text c-text--gray u-osb-xs">{{ 'Services.Button.Watch_Video' | translate }}</p>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- Card overlay -->
		<div class="c-card__overlay" [ngClass]="{'c-card__overlay--open': vm.overlayOpen}" *ngIf="!vm.isMinimal && !vm.partnerMode">
			<div class="c-content c-content--flex c-content--grow u-no-pb" *ngIf="vm.service?.description?.length > vm.charLimit && vm.overlayContent===2">
				<div class="o-grid o-grid--center-v">
					<div class="o-grid__cell u-no-p">
						<p class="c-text c-text--bold c-text--lg u-osb-xs">{{ vm.service?.user?.firstname }} {{ vm.service?.user?.lastname }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" (click)="vm.closeOverlay()">
						<button id="closeServiceDetailsButton{{vm.service?.id}}" class="c-button c-button--icon c-button--tp">
							<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
							<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
						</button>
					</div>
				</div>
				<p class="c-text c-text--wrap u-ost-sm">{{ vm.service?.description }}</p>
				<p class="c-text {{vm.textColor}} c-text--right" *ngIf="vm.service?.parentLicenseNumber" style="margin-top:auto;">{{ 'Subscription.Label.Business_LicenseNumber' | translate }}: {{ vm.service?.parentLicenseNumber }}</p>
			</div>
		</div>
	</div>
	<div class="c-content c-content--footer" [ngClass]="{'c-content--overlay': vm.overlayOpen}" *ngIf="!vm.isMinimal">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--right u-no-p">
				<div class="o-grid" *ngIf="vm.partnerMode">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--right u-no-p">
						<button id="contactPartnerButton{{vm.service?.id}}" type="button" class="c-button {{ vm.buttonTheme1 }} c-button--narrow c-button--fit" (click)="vm.openPartnerContactRequest()">{{ 'Partners.Contact.Button' | translate }}</button>
					</div>
				</div>
				<div class="o-grid" *ngIf="!vm.partnerMode">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--right u-no-p">
						<button id="startBookingButton{{vm.service?.id}}" type="button" class="c-button {{ vm.buttonTheme1 }} c-button--narrow c-button--fit u-no-wrap" *ngIf="vm.service?.nextAvailableTime" (click)="vm.redirectToBooking()">{{ 'Services.Button.Book' | translate }}</button>
						<button id="requestTimeButton{{vm.service?.id}}" type="button" class="c-button {{ vm.buttonTheme1 }} c-button--narrow c-button--fit" (click)="vm.openBookingEnquiry()" *ngIf="!vm.service?.nextAvailableTime && !vm.service?.chatBot">{{ 'Services.Other.Enquire_Time' | translate }}</button>
						<button id="chatBotStartButton{{vm.service?.id}}" type="button" class="c-button {{ vm.buttonTheme1 }} c-button--narrow c-button--fit" (click)="vm.openChatBotIntroduction(vm.service?.id)" *ngIf="vm.service?.chatBot">{{ 'Services.Other.Start_Chat' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
